import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M6.00033 2.66699C3.05366 2.66699 0.666992 5.05366 0.666992 8.00033C0.666992 10.947 3.05366 13.3337 6.00033 13.3337C8.94699 13.3337 11.3337 10.947 11.3337 8.00033C11.3337 5.05366 8.94699 2.66699 6.00033 2.66699ZM8.00033 7.00033H6.66699V10.3337H5.33366V7.00033H4.00033V6.00033H8.00033V7.00033ZM13.5003 2.50033L15.3337 3.33366L13.5003 4.16699L12.667 6.00033L11.8337 4.16699L10.0003 3.33366L11.8337 2.50033L12.667 0.666992L13.5003 2.50033ZM13.5003 11.8337L15.3337 12.667L13.5003 13.5003L12.667 15.3337L11.8337 13.5003L10.0003 12.667L11.8337 11.8337L12.667 10.0003L13.5003 11.8337Z",
            fill: "#E2E1E5"
        })
    }));
};
export default Icon;
